module.exports = __webpack_public_path__ + "static/media/icon-tree.cb276e38.png";